import { actionDeclarer } from '../services/actionDeclarer';

export const {
	SET,
	UPDATE
} = actionDeclarer;

export const useFormReducer = (
	state,
	{
		type,
		payload
	}
) => {
	switch ( type ) {
		case SET:
			if ( typeof payload === 'function' ) {
				return payload( state );
			}

			return payload;
		case UPDATE:
			return {
				...state,
				[ payload.name ]: payload.value
			};
		default:
			return state;
	}
};
